import React, { useEffect, useState } from "react";
import {
  CloseIconSvg,
  CloseModalProfile,
  ContainerContentModal,
  ContentMenu,
  ContentModalProfile,
  ContentPersonIcon,
  ContentPreview,
  DisplayNameMenu,
  GeneralContainer,
  Picture,
  ProfilePicture,
  TitleMenu,
} from "./ModalProfile.styled";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import {
  Box,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from "@mui/material";
import ReactLoading from "react-loading";
import { theme as themeConfig } from "../../themes/themes";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import ImageIcon from "@mui/icons-material/Image";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import FaceIcon from "@mui/icons-material/Face";
import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";
import colorsavatar from "../../assets/mocks/colorsavatar.json";
import menuprofile from "../../assets/mocks/menuprofile.json";
import Monogram from "../Monogram/Monogram";
import AvatarPhoto from "../AvatarPhoto/AvatarPhoto";
import TPAvatar from "../TPAvatar/TPAvatar";
import { useLazyQuery, useMutation } from "@apollo/client";
import { MY_PROFILE_PICTURE } from "../../GraphQL/Queries";
import { UPDATE_MY_PROFILE_PICTURE } from "../../GraphQL/Mutations";
import { NotificationManager } from "react-notifications";
import {
  getListProfilePhotos,
  getProfilePhotoByName,
} from "../../services/UserProfilePhotosManager";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import PropTypes from "prop-types";

const ModalProfile = ({ user, setOpenModalProfile }) => {
  const [titleMenu, setTitleMenu] = useState("");
  const [photosAvatar, setPhotosAvatar] = useState();
  const [tpAvatars, setTpAvatars] = useState();
  const [photoSelected, setPhotoSelected] = useState("");
  const [tpAvatarSelected, setTPAvatarSelected] = useState("");
  const [colorSelected, setColorSelected] = useState();
  const [photoProfile, setPhotoProfile] = useState("");

  const [valuePictureWidth, setValuePictureWidth] = useState(50);
  const [shortName, setShortName] = useState();
  const [selectedItem, setSelectedItem] = useState("Monogram");
  const [openPalette, setOpenPalette] = useState(false);
  const [myProfilePicture, setMyProfilePicture] = useState();
  const [updateMyProfilePicture] = useMutation(UPDATE_MY_PROFILE_PICTURE);
  const [runQueryMyProfilePicture, { loading: loadingPhotoProfile }] =
    useLazyQuery(MY_PROFILE_PICTURE, {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setMyProfilePicture(data.myProfilePicture);
      },
    });

  const handleGetListProfilePhotos = (id) => {
    getListProfilePhotos(id).then((data) => {
      let photos = data.filter((item) => item.avatarType === "Photo");
      if (Array.isArray(photos)) {
        setPhotosAvatar(photos);
      }
    });
  };

  const handleGetListProfileTpAvatars = (id) => {
    getListProfilePhotos(id).then((data) => {
      let avatars = data.filter((item) => item.avatarType === "TpAvatar");
      if (Array.isArray(avatars)) {
        setTpAvatars(avatars);
      }
    });
  };

  const handleItemClick = (text) => {
    setSelectedItem(text);
  };

  const handleChangePictureWidth = (event, newValue) => {
    setValuePictureWidth(newValue);
  };

  const handleClickPalette = (open) => {
    setOpenPalette(!open);
  };

  const handlePickerColorChange = (color) => {
    setColorSelected(color.hex);
  };

  const handleSaveMonogram = () => {
    if (colorSelected) {
      updateMyProfilePicture({
        variables: {
          avatarType: "MONOGRAM",
          jsonConfig: `${colorSelected}`,
          imageName: "",
        },
        context: { clientName: "LinkUsers" },
      })
        .then((response) => {
          NotificationManager.success(
            "The photo profile was successfully updated",
            "",
            5000
          );
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.info(
        "you should select a new monogram before save",
        "",
        5000
      );
    }
  };

  const handleSavePhoto = () => {
    if (photoSelected?.name) {
      updateMyProfilePicture({
        variables: {
          avatarType: "PHOTO",
          jsonConfig: "",
          imageName: `${photoSelected.name.replace("UserProfilePicture/", "")}`,
        },
        context: { clientName: "LinkUsers" },
      })
        .then((response) => {
          NotificationManager.success(
            "The photo profile was successfully updated",
            "",
            5000
          );
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.info(
        "you should select a new photo before save",
        "",
        5000
      );
    }
  };

  const handleSaveTPAvatar = () => {
    if (tpAvatarSelected?.name) {
      updateMyProfilePicture({
        variables: {
          avatarType: "TP_AVATAR",
          jsonConfig: "",
          imageName: `${tpAvatarSelected.name.replace(
            "UserProfilePicture/",
            ""
          )}`,
        },
        context: { clientName: "LinkUsers" },
      })
        .then((response) => {
          NotificationManager.success(
            "The photo profile was successfully updated",
            "",
            5000
          );
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.info(
        "you should select a new tp avatar before save",
        "",
        5000
      );
    }
  };

  const handleGetProfilePhotoByName = (id, name) => {
    getProfilePhotoByName(id, name).then((data) => {
      let photo = data[0].url;
      if (photo) {
        setPhotoProfile(photo);
      }
    });
  };

  useEffect(() => {
    if (user) {
      setShortName(
        `${user.displayName.split(" ")[0].charAt(0) +
        "" +
        user.displayName.split(" ")[1].charAt(0)
        }`
      );
    }
  }, [user]);

  useEffect(() => {
    setTitleMenu("Change Profile Picture");
    handleGetListProfilePhotos(1);
    handleGetListProfileTpAvatars(1);
  }, []);

  useEffect(() => {
    runQueryMyProfilePicture({
      context: { clientName: "LinkUsers" },
    });
  }, [updateMyProfilePicture]);

  useEffect(() => {
    if (myProfilePicture && myProfilePicture.avatarType === "TP_AVATAR") {
      setTPAvatarSelected(myProfilePicture);
      handleGetProfilePhotoByName(1, `${myProfilePicture.imageName}`);
    }
    if (myProfilePicture && myProfilePicture.avatarType === "PHOTO") {
      setPhotoSelected(myProfilePicture);
      handleGetProfilePhotoByName(1, `${myProfilePicture.imageName}`);
    }
  }, [myProfilePicture]);

  useEffect(() => {
    if (myProfilePicture && myProfilePicture.avatarType === "MONOGRAM") {
      setColorSelected(`${myProfilePicture.jsonConfig}`);
    }
  }, [myProfilePicture]);

  useEffect(() => {
    if (tpAvatarSelected?.url) {
      setPhotoProfile(tpAvatarSelected.url);
    }
  }, [tpAvatarSelected]);

  useEffect(() => {
    if (photoSelected?.url) {
      setPhotoProfile(photoSelected.url);
    }
  }, [photoSelected]);

  useEffect(() => {
    if (colorSelected) {
      setPhotoProfile("");
    }
  }, [colorSelected]);

  const renderMenuIcons = (name) => {
    switch (name) {
      case "BMS Photo":
        return <PhotoCameraIcon />;
      case "Photo":
        return <ImageIcon />;
      case "TP Avatar":
        return <FaceIcon />;
      case "Monogram":
        return <AccountCircleIcon />;
      case "Emoji":
        return <SentimentSatisfiedAltIcon />;
      default:
        break;
    }
  };

  return (
    <GeneralContainer>
      <span
        className="arrow-up"
        style={{
          position: "absolute",
          top: "-31px",
          right: "3.5%",
          zIndex: "4",
        }}
      ></span>
      <ContentModalProfile>
        <CloseModalProfile>
          <Tooltip title="close">
            <IconButton
              className="align-right close"
              onClick={() => setOpenModalProfile(false)}
            >
              <CloseIconSvg>
                <CloseIcon />
              </CloseIconSvg>
            </IconButton>
          </Tooltip>
        </CloseModalProfile>
        <ContainerContentModal>
          <ContentMenu>
            <TitleMenu>{titleMenu}</TitleMenu>
            <DisplayNameMenu>{user.displayName}</DisplayNameMenu>
            {loadingPhotoProfile && (
              <ProfilePicture>
                <ReactLoading type={"spinningBubbles"} color={themeConfig.text.primary} />
              </ProfilePicture>
            )}
            {!loadingPhotoProfile && (
              <ProfilePicture>
                <Picture
                  photo={`${photoProfile}`}
                  bgColor={`${colorSelected}`}
                  valuePictureWidth={valuePictureWidth}
                >
                  {!photoProfile &&
                    (colorSelected ? (
                      shortName
                    ) : (
                      <ContentPersonIcon>
                        <PersonOutlineIcon
                          className="person-icon"
                          style={{ fontSize: `${valuePictureWidth}px` }}
                        />
                      </ContentPersonIcon>
                    ))}
                </Picture>
              </ProfilePicture>
            )}

            <Box sx={{ width: "100%" }}>
              <Stack
                spacing={2}
                direction="row"
                sx={{ mb: 1, mx: 8 }}
                alignItems="center"
              >
                <Slider
                  style={{ color: "#aaa" }}
                  aria-label="picture-width"
                  min={30}
                  max={60}
                  value={valuePictureWidth}
                  onChange={handleChangePictureWidth}
                />
              </Stack>
            </Box>
            <MenuList>
              {menuprofile.menulist.map((m) => (
                <MenuItem
                  key={m.name}
                  selected={selectedItem === m.name}
                  onClick={() => handleItemClick(m.name)}
                >
                  <ListItemIcon>{renderMenuIcons(m.name)}</ListItemIcon>
                  <ListItemText>{m.name}</ListItemText>
                </MenuItem>
              ))}
            </MenuList>
          </ContentMenu>
          <ContentPreview>
            {selectedItem === "Photo" && (
              <AvatarPhoto
                handleSavePhoto={handleSavePhoto}
                photoSelected={photoSelected}
                setPhotoSelected={setPhotoSelected}
                photosavatar={photosAvatar}
                setOpenModalProfile={setOpenModalProfile}
              />
            )}
            {selectedItem === "TP Avatar" && (
              <TPAvatar
                handleSaveTPAvatar={handleSaveTPAvatar}
                tpAvatarSelected={tpAvatarSelected}
                setTPAvatarSelected={setTPAvatarSelected}
                tpavatars={tpAvatars}
                setOpenModalProfile={setOpenModalProfile}
              />
            )}
            {selectedItem === "Monogram" && (
              <Monogram
                colorsavatar={colorsavatar.colors}
                colorSelected={colorSelected}
                setColorSelected={setColorSelected}
                shortName={shortName}
                handleClickPalette={handleClickPalette}
                openPalette={openPalette}
                handlePickerColorChange={handlePickerColorChange}
                handleSaveMonogram={handleSaveMonogram}
                setOpenModalProfile={setOpenModalProfile}
              />
            )}
          </ContentPreview>
        </ContainerContentModal>
      </ContentModalProfile>
    </GeneralContainer>
  );
};

export default ModalProfile;

ModalProfile.propTypes = {
  user: PropTypes.object,
  setOpenModalProfile: PropTypes.func,
};
